<template>
  <div>
    <router-link class="link-back" :to="'/predictions/projects'">
      <div>
        &larr; Back to projects
      </div>
    </router-link>
    <h1 v-bg-typography="'h1'" :style="{ marginTop: '10px' }">
      {{ project.title }}
    </h1>
    <p>
      Created by: <b>{{ project.creator }}</b> - Credits left:
      <b>{{ credits }}</b>
    </p>
    <div class="buttons">
      <bg-button text="New heatmap" style="margin-top: 30px;"></bg-button>
    </div>
    <div class="cards">
      <Card
        v-for="version in project.versions"
        :key="version.id"
        :heatmap="version"
        @analyze="
          $router.push(
            `/predictions/projects/${$route.params.id}/heatmaps/${version.id}`
          )
        "
      />
    </div>
  </div>
</template>

<script>
import BgTypography from "@/directives/bg-typography";
import List from "@/components/list";
import BgButton from "@/components/bg-button";
import BgField from "@/components/bg-field";
import BgInput from "@/components/bg-input";
import Card from "@/components/heatmap-card";

export default {
  components: {
    List,
    BgButton,
    BgField,
    BgInput,
    Card,
  },
  directives: {
    BgTypography,
  },
  data() {
    return {
      credits: 999,
      selected: null,
      project: {
        creator: "Max van Kaathoven",
        title: "Landingpage designs",
        versions: [
          {
            title: "version 6",
            image: "",
            clarity: 8.3,
            readability: 3.5,
            added: "01-02-2021",
            addedBy: "Max van Kaathoven",
            id: 6,
          },
          {
            title: "version 5",
            image: "",
            clarity: 8.3,
            readability: 3.5,
            added: "01-02-2021",
            addedBy: "Max van Kaathoven",
            id: 5,
          },
          {
            title: "version 4",
            image: "",
            clarity: 8.3,
            readability: 3.5,
            added: "01-02-2021",
            addedBy: "Max van Kaathoven",
            id: 4,
          },
          {
            title: "version 3",
            image: "",
            clarity: 8.3,
            readability: 3.5,
            added: "01-02-2021",
            addedBy: "Max van Kaathoven",
            id: 3,
          },
          {
            title: "version 2",
            image: "",
            clarity: 8.3,
            readability: 3.5,
            added: "01-02-2021",
            addedBy: "Max van Kaathoven",
            id: 2,
          },
          {
            title: "version 1",
            image: "",
            clarity: 8.3,
            readability: 3.5,
            added: "01-02-2021",
            addedBy: "Max van Kaathoven",
            id: 1,
          },
        ],
      },
    };
  },
  methods: {
    selectVersion(id) {
      this.selected = id;
    },
    selectHeatmap(val) {
      const current = this.$route.params.id;
      this.$router.push(`/predictions/${current}/heatmap/${val}`);
    },
  },
};
</script>

<style scoped lang="scss">
h1 {
  margin-bottom: 10px;
}

.cards {
  display: flex;
  flex-wrap: wrap;
  gap: 25px;
  max-width: 100%;
}

.buttons {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}
</style>
